import { Stack } from 'ui/stack';
import { Box } from 'ui/box';

import { Chip } from 'components/partials/insight-modal/shared/components';
import NavButton from 'containers/user/home/components/shared/navigation-button';
import BlockHeader from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/context-data-panel/components/block-header';

import { getFilterDisplayName } from 'constants/report-filters-mapping';

import type { ContextMetadata } from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/context-data-panel/monitoring-context';

interface ReportContextProps {
  metadata: ContextMetadata | undefined;
  clientId: string | number | undefined;
  sourceId: string | number | undefined;
  showViewReport?: boolean;
  isAdminView?: boolean;
}

const ReportContext = ({
  metadata,
  clientId,
  sourceId,
  showViewReport = true,
  isAdminView = true,
}: ReportContextProps): React.JSX.Element => {
  const reportLink = isAdminView
    ? `/admin/clients/${clientId}/reports/${sourceId}`
    : `/reports/${sourceId}`;

  return (
    <Stack sx={{ gap: 2 }}>
      <Stack direction="row" sx={{ gap: 4, alignItems: 'flex-start' }}>
        <Box>
          <BlockHeader title="Report" />
          <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1, mb: 1 }}>
            <Chip>{metadata?.source || 'Report'}</Chip>
          </Stack>
          {showViewReport && metadata?.source && (
            <NavButton
              link={reportLink}
              text="View report"
              customClass="text-blue-600 text-sm hover:underline inline-flex items-center gap-1"
            />
          )}
        </Box>

        {metadata?.reportFilters && !!metadata.reportFilters.length && (
          <Box>
            <h4 className="font-semibold text-gray-700 mb-1">
              Filters applied
            </h4>
            <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1 }}>
              {metadata.reportFilters.map((filter, index) => (
                <Chip key={index}>
                  {typeof filter === 'string'
                    ? filter
                    : `${getFilterDisplayName(filter.column)}: ${
                        Array.isArray(filter.values)
                          ? filter.values.join(', ')
                          : filter.values
                      }`}
                </Chip>
              ))}
            </Stack>
          </Box>
        )}
      </Stack>

      {metadata?.relatedGoals && !!metadata.relatedGoals.length && (
        <Box>
          <BlockHeader title="Related goals" />
          <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1 }}>
            {metadata.relatedGoals.map((goal, index) => (
              <Chip key={index}>{goal}</Chip>
            ))}
          </Stack>
        </Box>
      )}
    </Stack>
  );
};

export default ReportContext;
